<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>

<script>
import { mapActions, mapState } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import ClampList from '@/components/ui/ClampList'
import FallbackAvatar from '@/components/ui/FallbackAvatar'

export default {
  name: 'UserItem',
  components: {
    ClampList,
    FallbackAvatar,
  },
  props: {
    user: Object,
    occasion: Boolean,
  },
  computed: {
    ...mapFields('chat', [
      'conversationId',
      'isOpen',
      'selectedPanel',
    ]),
    ...mapState('users', ['userFieldIdentifiers']),
    ...mapState('auth', ['settings']),
  },
  methods: {
    ...mapActions('chat', ['chat']),
    async createUserConversation() {
      const chat = await this.chat()
      chat.createDirectMessageConversation([this.user.id]).then(({ data }) => {
        this.isOpen = true
        this.conversationId = data.conversation_id
        this.selectedPanel = 'ChatConversation'
      })
    },
  },
}
</script>
